<template>
  <fragment>
    <v-toolbar elevation="1" height="50" color="#0F1547">
      <v-btn icon @click="closeModal">
        <v-icon style="color: white">mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title style="color: white"> Exercices PPG </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn color="success" small @click="validExercise" v-if="selectedExercise.length > 0">
        <v-icon small>mdi-check-bold</v-icon>
        &nbsp; Valider
      </v-btn>
    </v-toolbar>

    <v-container fluid style="height: 778px; padding-top: 16px">
      <!-- Content -->
      <v-row class="overflow-hidden" style="max-height: 100%">
        <!-- List Exercises -->
        <v-col cols="4" class="d-flex flex-column" style="max-height: 100%">
          <v-card class="overflow-hidden" style="width: 100%; height: 100%; display: flex; flex-direction: column;">
            <!-- Search Box -->
            <v-row class="flex-grow-0">
              <v-col>
                <v-text-field label="Recherche" v-model="keyword" flat solo-inverted hide-details clearable clear-icon="mdi-close-circle-outline" />
              </v-col>
            </v-row>
            <v-row class="flex-grow-0">
              <v-col class="pl-5">
                <v-btn @click="toggle" class="mr-3 float-end" text>
                  <template v-if="!isAllOpen"> Tout ouvrir </template>
                  <template v-else> Tout fermer </template>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <!-- Tree view -->
            <v-row class="overflow-hidden" style="max-height: 100%">
              <v-col class="overflow-hidden" style="max-height: 100%;">
                <div class="overflow-auto" style="max-height: 100%;">
                <v-treeview
                  ref="tree"
                  dense
                  open-on-click
                  hoverable
                  return-object
                  activatable
                  :search="keyword"
                  selection-type="independent"
                  :items="exercisesTree"
                  :active="activedItem"
                  style="max-height: 100%; width: max-content;"
                  @update:active="selectExercise"
                />
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- Details Exercise -->
        <v-col cols="8" class="d-flex flex-column" style="max-height: 100%">
          <v-card v-if="selectedExercise.length > 0" style="width: 100%;">
            <!-- title -->
            <v-card-title style="color: #0f1547">{{ selectedExercise[0].name }}</v-card-title>

            <v-card-text>
              <!-- Exercise info -->
              <v-row align="center" class="mx-0">
                <!-- text infos -->
                <v-col cols="6" class="no-padding-sides">
                  <!-- type -->
                  <div class="mt-3" v-if="selectedExercise[0].type">
                    <label class="font-weight-bold t-blue">Type</label>
                    {{ selectedExercise[0].type }}
                  </div>

                  <!-- groupe -->
                  <div class="mt-3" v-if="selectedExercise[0].groupe">
                    <label class="font-weight-bold t-blue">Groupe</label>
                    {{ selectedExercise[0].groupe }}
                  </div>

                  <!-- materiel1 -->
                  <div class="mt-3" v-if="selectedExercise[0].materiel1">
                    <label class="font-weight-bold t-blue">Matériel 1</label>
                    {{ selectedExercise[0].materiel1 }}
                  </div>

                  <!-- materiel2 -->
                  <div class="mt-3" v-if="selectedExercise[0].materiel2">
                    <label class="font-weight-bold t-blue">Matériel 2</label>
                    {{ selectedExercise[0].materiel2 }}
                  </div>

                  <!-- critereDeReussite -->
                  <div class="mt-3" v-if="selectedExercise[0].critereDeReussite">
                    <label class="font-weight-bold t-blue">Critères de réussite</label>
                    {{ selectedExercise[0].critereDeReussite }}
                  </div>

                  <!-- criteresDeRealisation -->
                  <div class="mt-3" v-if="selectedExercise[0].criteresDeRealisation">
                    <label class="font-weight-bold t-blue">Critères de réalisation</label>
                    {{ selectedExercise[0].criteresDeRealisation }}
                  </div>

                  <!-- complexification -->
                  <div class="mt-3" v-if="selectedExercise[0].complexification">
                    <label class="font-weight-bold t-blue">Complexification</label>
                    {{ selectedExercise[0].complexification }}
                  </div>

                  <!-- simplification -->
                  <div class="mt-3" v-if="selectedExercise[0].simplification">
                    <label class="font-weight-bold t-blue">Simplification</label>
                    {{ selectedExercise[0].simplification }}
                  </div>

                  <!-- varianteMateriel -->
                  <div class="mt-3" v-if="selectedExercise[0].varianteMateriel">
                    <label class="font-weight-bold t-blue">Variante matériel</label>
                    {{ selectedExercise[0].varianteMateriel }}
                  </div>
                </v-col>

                <!-- Videos -->
                <v-col cols="6" class="no-padding-sides">
                  <div style="background: #fff" class="p-2">
                    <select @change="(e) => changeVideo(e)" class="select mb-5">
                      <option :value="selectedExercise[0].multiCamVideoLink">Multicam</option>
                      <option :value="selectedExercise[0].faceCamVideoLink">Face</option>
                      <option :value="selectedExercise[0].profileCamVideoLink">Profil</option>
                      <option :value="selectedExercise[0].treeQuarterCamVideoLink">Trois quart</option>
                    </select>

                    <div class="container-video">
                      <iframe style="border: none" :src="video || selectedExercise[0].multiCamVideoLink" class="embed" />
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </fragment>
</template>

<script>
import { bus } from "../../main";
import { Fragment } from "vue-fragment";
import { getPPGExerciseAsyncsAsync } from "../../api/exerciseApi";

export default {
  name: "ppg-list-v2",

  components: {
    Fragment,
  },

  props: ["close"],

  data() {
    return {
      video: null,
      isAllOpen: false,
      keyword: null,
      activedItem: [],
      selectedExercise: [],
      exercisesTree: [],
      exercisesGroupByParentId: {},
    };
  },

  async mounted() {
    const exercises = await getPPGExerciseAsyncsAsync();

    // Création d'un object contenant les enfants
    exercises.forEach((item) => {
      item.id = this.randomId();

      item.children.forEach((item) => {
        item.id = this.randomId();

        item.children.forEach((item) => {
          Object.assign(item, item.exercise);
        });
      });
    });

    this.exercisesTree = exercises;
  },

  watch: {
    keyword: function (e) {
      if (e !== null) {
        this.$refs.tree.updateAll(true);
        this.isAllOpen = true;
      }
    },
  },

  methods: {
    // Select an exercise from the tree
    selectExercise(item) {
      if (item.length > 0 && item[0].exercise) {
        this.selectedExercise = item;
        this.activedItem = item;
      } else {
        this.activedItem = [];
      }
    },

    // Validate the selected exercise : close modal and send selected to parent
    validExercise() {
      bus.$emit("reference", this.selectedExercise[0], "PPG");
      this.emptySelectionAndCollapseTree();
      this.$emit("close-menu");
      this.close();
    },

    // Change selected video
    changeVideo: function (e) {
      this.video = e.target.value;
    },

    // Unselect and close the modal
    closeModal() {
      this.emptySelectionAndCollapseTree();
      this.$emit("close-menu");
      this.close();
    },

    // Empty selected and collapse tree
    emptySelectionAndCollapseTree() {
      // Empty selected value
      this.selectedExercise = [];
      // Empty active item
      this.activedItem = [];
      // Collapse tree
      this.isAllOpen = false;
      this.$refs.tree.updateAll(false);
    },

    // Expand collapse tree
    toggle() {
      if (this.isAllOpen) {
        this.$refs.tree.updateAll(false);
      } else {
        this.$refs.tree.updateAll(true);
      }

      this.isAllOpen = !this.isAllOpen;
    },

    // generate random id
    randomId() {
      return Math.random().toString(36).substr(2, 9);
    },
  },
};
</script>

<style lang="scss" scoped>
.tree-item {
  cursor: pointer;
}
</style>
